import * as React from 'react'
// components
import { PopoverModal } from 'components/UI'
// icons
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// utils
import { size } from 'polished'

// styled
export const DotsIcon = styled(({ iconSize, ...props }) => <DotsIconOrigin {...props} />)<{ iconSize: number }>`
  && {
    cursor: pointer;
    ${({ iconSize }) => size(`${iconSize ? iconSize : 20}px`)};
  }
`
const Item = styled.div`
  cursor: pointer;
  font-size: 16px;
  margin: 8px 0;
  padding: 5px 15px;

  &:hover {
    background-color: ${colors.gray230};
  }
`

// constants
const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  },
  PaperProps: {
    style: {
      width: '90px'
    }
  }
}

// types
interface IIncomingProps {
  iconSize?: number
  handleOnClick?: () => void
}

const DeleteButton: React.FC<IIncomingProps> = ({ handleOnClick, iconSize }) => {
  const handleClick = (closePopup) => {
    closePopup()
    handleOnClick()
  }

  return (
    <PopoverModal {...MODAL_PROPS} trigger={<DotsIcon data-testid='dots-icon' iconSize={iconSize} />}>
      {({ closePopup }) => (
        <Item data-testid='delete-button' onClick={() => handleClick(closePopup)}>
          Delete
        </Item>
      )}
    </PopoverModal>
  )
}

export default DeleteButton
